import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsArray, ValidateNested, IsBoolean, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class TranslateToServiceType {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  @IsOptional()
  attributePrototypeId!: number | null;
  @IsString()
  @Expose()
  @IsOptional()
  attributeValue!: string | null;
  @IsString()
  @Expose()
  changeTo!: string;

  isChange!: boolean;
}

export class ServiceType {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  vat!: string;
  @IsString()
  @Expose()
  documentType!: string;
  @IsString()
  @Expose()
  code!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @Expose()
  @IsArray()
  @Type(() => TranslateToServiceType)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  translateToServiceTypes!: Array<TranslateToServiceType>;
}

export class ServiceTypeResponse extends GenericTableResponse<ServiceType> {
  @Expose()
  @IsArray()
  @Type(() => ServiceType)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ServiceType>;
}
